<template>
  <ul class="collapsible popout">
    <li class="collapsible-margin active" id="player">
      <div class="collapsible-header">
        <i class="material-icons">casino</i>Select Bot Nation
      </div>
      <div class="collapsible-body tech row">
        <div
          class="col s12 m6 offset-m3"
          style="margin-top: .7vh"
          v-for="nation in nations"
          :key="nation"
        >
          <button
            @click="setNation(nation.name)"
            class="waves-effect waves-light btn col s12 m8 offset-m2"
          >
            {{nation.name}}
          </button>
        </div>
      </div>
    </li>
  </ul>
</template>

<script>
import { defineComponent, onMounted} from "vue";
import nations from "../nations.js";
import store from "../store.js"

export default defineComponent({
  setup() {
    onMounted(() => {
      var elems = document.querySelectorAll(".collapsible");
      window.M.Collapsible.init(elems, {});
    });
    function setNation(newNation) {
        const nation = nations.filter(x => x.name === newNation);
        store.setNation(nation[0])
        console.log(store.bot.nation)
        this.$emit('nation-selected')
    }
    return {
      nations,
      setNation
    };
  },
});
</script>

<style></style>
